<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<mat-checkbox class="mb-3" id="isOskar" name="isOskar" [(ngModel)]="filters.is_oskar"
						>Czy należy do Grupy Oskar?</mat-checkbox
					>
					<div class="mb-3">
						<label for="filters.is_active" class="mt-3">Czy jest aktywny?</label>
						<ng-select
							id="filters.is_active"
							name="filters.is_active"
							[(ngModel)]="filterIsActive"
							(ngModelChange)="onIsActiveChange($event)"
							[multiple]="false"
							[searchable]="false"
						>
							<ng-option [value]="IsActiveOption.ACTIVE">Aktywne</ng-option>
							<ng-option [value]="IsActiveOption.NOT_ACTIVE">Nieaktywne</ng-option>
							<ng-option [value]="IsActiveOption.ALL">Wszystkie</ng-option>
						</ng-select>
					</div>

					<div class="mb-3">
						<label for="filters.address_location" class="mt-3">Adres firmy (Miasto)</label>
						<ng-select
							id="filters.address_location"
							name="filters.address_location"
							[(ngModel)]="filters.address_location"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of locations" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label class="form-label" for="filters.code_merlinx">Kod merlinX</label>
						<input
							type="text"
							class="form-control"
							id="filters.code_merlinx"
							name="filters.code_merlinx"
							[(ngModel)]="filters.code_merlinx"
						/>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row row-full w-100">
					<div class="row w-100">
						<div class="col-sm-7 text-center">
							<button mat-raised-button color="basic" type="button" class="me-2" (click)="filtersClear()">
								Wyczyść
							</button>
							<button mat-raised-button color="accent" type="button" (click)="filtersDefault()">
								Domyślne
							</button>
						</div>
						<div class="col-sm-5 text-end">
							<button
								mat-raised-button
								color="primary"
								type="button"
								class="me-2"
								(click)="filtersSave()"
							>
								Pokaż
							</button>
							<button
								mat-raised-button
								color="warn"
								type="button"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
